import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-encabezado',
  templateUrl: './encabezado.component.html',
  styleUrls: ['./encabezado.component.css'],
})
export class EncabezadoComponent implements OnInit {
  @Input() badgeText = '';
  @Input() titulo = '';
  @Input() descripcion = '';
  // Línea opcional "Proceso: X", se pinta separada de la descripción para
  // no depender de <br> (la descripción se interpola como texto, no HTML).
  @Input() procesoActual: string | null = null;
  @Input() contador: number | string | null = null;
  @Input() contadorLabel = '';
  @Input() mostrarContador = true;
  
 // Controla si se pinta el círculo de estado (rojo/verde)
  @Input() mostrarIndicador = false; 
  // Define si el círculo es verde (true) o rojo (false)
  @Input() indicadorActivo = false;
  

  constructor() {}

  ngOnInit(): void {}
}